import React from 'react';

/**
 * 🍎 Skeleton Card - Apple-style loading placeholder
 * Componente per mostrare uno skeleton durante il caricamento degli articoli
 */
const SkeletonCard: React.FC = () => {
  return (
    <div className="card p-6 animate-pulse">
      {/* Image skeleton */}
      <div className="w-full h-48 bg-gray-200 dark:bg-gray-800 rounded-xl mb-6" />
      
      {/* Content skeleton */}
      <div className="space-y-4">
        {/* Badge */}
        <div className="w-20 h-6 bg-gray-200 dark:bg-gray-800 rounded-full" />
        
        {/* Title */}
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 dark:bg-gray-800 rounded w-3/4" />
          <div className="h-6 bg-gray-200 dark:bg-gray-800 rounded w-1/2" />
        </div>
        
        {/* Excerpt */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded" />
          <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded" />
          <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded w-5/6" />
        </div>
        
        {/* Meta info */}
        <div className="flex items-center space-x-4 pt-4">
          <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded w-24" />
          <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded w-20" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;

